import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IPicqerCredentials {
    api_key: string,
    account_subdomain: string,
    idreturn_status: number,
    idreturn_reason: number,
}

class PicqerCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IPicqerCredentials = {} as IPicqerCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get api_key() { return this._changes.api_key; }
    public get account_subdomain() { return this._changes.account_subdomain; }
    public get idreturn_status() { return this._changes.idreturn_status; }
    public get idreturn_reason() { return this._changes.idreturn_reason; }

    public set api_key(v: string) { this._changes.api_key = v; }
    public set account_subdomain(v: string) { this._changes.account_subdomain = v; }
    public set idreturn_status(v: number) { this._changes.idreturn_status = v; }
    public set idreturn_reason(v: number) { this._changes.idreturn_reason = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IPicqerCredentials;
    }

    public getUpdatedModel(): IPicqerCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default PicqerCredentialsStore;
